import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import ValidationMessage from './ValidationMessage';

class LongitudeValidation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isInvalid: false
        };
    }

    componentWillMount() {
        this.validate();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.validate();
        }
    }

    componentWillUnmount() {
        // Whenever the component is unmount then it needs to let the parent know.
        if (this.props.onValidated) {
            this.props.onValidated(false, null);
        }
    }

    getDefaultMessage() {
        const defaultMessage = (
            <ValidationMessage controlName={this.props.controlLabel} message=" is not a valid Longitude." />
        );
        const message = this.props.children || defaultMessage;
        return message;
    }

    validate() {
        const isInvalid = !validator.isEmpty(this.props.value)
            && !validator.isLatLong(`0, ${this.props.value}`);
        const message = this.getDefaultMessage();
        const isCritical = this.props.isCritical;

        this.setState({
            isInvalid
        });

        if (this.props.onValidated) {
            this.props.onValidated(isInvalid, message);
        }

        return { isInvalid, message, isCritical };
    }

    render() {
        if (this.props.displayInSummary || !this.state.isInvalid) {
            return null;
        }
        const message = this.getDefaultMessage();
        return (message);
    }
}

LongitudeValidation.defaultProps = {
    children: null,
    displayInSummary: false,
    isCritical: false
};

LongitudeValidation.propTypes = {
    controlLabel: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    displayInSummary: PropTypes.bool,
    isCritical: PropTypes.bool,
    children: PropTypes.element,
    onValidated: PropTypes.func
};

export default LongitudeValidation;
